import { render, staticRenderFns } from "./JitsiCallLog.vue?vue&type=template&id=58db479d&"
import script from "./JitsiCallLog.vue?vue&type=script&lang=js&"
export * from "./JitsiCallLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports